import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Source Onboarding', value: 'source_onboarding_name' },
  { text: 'Merchant Name', value: 'merchant_name' },
  { text: 'MID', value: 'mid'},
  { text: 'NMID', value: 'nmid'},
  { text: 'MPAN', value: 'mpan'},
  { text: 'Alamat Lengkap', value: 'address' },
  { text: 'Kriteria Merchant', value: 'merchant_criteria' },
  { text: 'No. Handphone', value: 'mobile_phone' },
  { text: 'Jenis QR', value: 'qr_type' },
  { text: 'Settlement Type', value: 'settlement_type_name'},
  { text: 'Tanggal Active', value: 'created_at'},
  { text: 'Tanggal Inactive', value: 'deactivated_at'},
  { text: 'Status', value: 'status'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {

  source_onboarding: '',
  merchant_name: '',
  mid: '',
  nmid: '',
  mpan: '',
  qr_type: '',
  deactivated_at: [],
  mobile_phone: '',
  merchant_criteria: '',
  address: '',
  settlement_type: '',
  status: '',
  created_at: [],
};
